import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase.js';
import Field from '../components/Field.jsx';
import ErrorBanner, { SuccessBanner } from '../components/ErrorBanner.jsx';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    if (resetError) {
      setError(resetError.message);
      setBusy(false);
      return;
    }

    // Always report success, even for an unknown address: a differing response
    // would let anyone test which staff emails exist.
    setSent(true);
    setBusy(false);
  }

  return (
    <div className="centered-page">
      <form className="card" onSubmit={handleSubmit}>
        <h1>Reset your password</h1>

        <ErrorBanner error={error} />
        {sent && (
          <SuccessBanner>
            If an account exists for {email}, a reset link is on its way. It
            expires in an hour.
          </SuccessBanner>
        )}

        <p className="muted">
          We’ll email you a link to set a new password.
        </p>

        <Field
          label="Email address"
          type="email"
          value={email}
          onChange={setEmail}
          autoComplete="username"
          disabled={busy}
        />

        <button type="submit" className="btn btn--primary" disabled={busy}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>

        <p className="card__footer">
          <Link to="/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  );
}

export default ForgotPasswordPage;
